export const REQUEST_TYPES = {
  add_new_update: 'add_new_update',
  edit_update: 'edit_update',
  edit_handouts: 'edit_handouts',
  delete_update: 'delete_update',
};
